// import React, { Fragment } from "react";
// import {
//   Card,
//   CardActionArea,
//   CardContent,
//   Typography,
//   Grid,
// } from "@mui/material";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import LocalMallIcon from "@mui/icons-material/LocalMall";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { customeStyle } from "utils/style";
// import { useSelector } from "react-redux";

// const optionIcons = {
//   shipping: <LocalShippingIcon sx={{ fontSize: "0.9rem" }} />,
//   store_pickup: <LocalMallIcon sx={{ fontSize: "1rem" }} />,
//   room_deliver: <LocalMallIcon sx={{ fontSize: "1rem" }} />,
// };

// const optionLabels = {
//   shipping: "Shipping",
//   store_pickup: "Pickup at Store",
//   room_deliver: "Deliver to Room",
// };

// const ShippingOptionCard = ({ selected, onSelcted, selectAddress }) => {
//   const handleSelect = (option) => {
//     selectAddress();
//     onSelcted(option);
//   };

//   const websiteInfo = useSelector((state) => state.webDetails.websiteInfo);
//   const deliveryOptions = websiteInfo?.delivery_option || [];

//   return (
//     <Fragment>
//       <Grid item pb={2}>
//         <Typography fontSize={customeStyle.typography.subhading} gutterBottom>
//           Please select a delivery method:
//         </Typography>
//       </Grid>
//       <Grid container spacing={{ xs: 2, md: 1 }}>
//         {deliveryOptions.length > 0 ? (
//           deliveryOptions.map((option) => (
//             <Grid key={option} item xs={6} sm={6} md={4}>
//               <Card
//                 sx={{
//                   overflow: "visible",
//                   borderRadius: "1rem",
//                   transition: "all 0.2s ease",
//                   backgroundColor: selected === option ? "#000" : "#fff",
//                   position: "relative",
//                 }}
//               >
//                 {selected === option && (
//                   <CheckCircleIcon
//                     sx={{
//                       position: "absolute",
//                       top: -5,
//                       right: -5,
//                       color: "#1976d2",
//                       fontSize: 20,
//                       backgroundColor: "#fff",
//                       borderRadius: "50%",
//                       zIndex: 99,
//                     }}
//                   />
//                 )}
//                 <CardActionArea onClick={() => handleSelect(option)}>
//                   <CardContent
//                     sx={{
//                       p: 1,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "0.2rem",
//                       borderRadius: "1rem",

//                       backgroundColor: selected === option ? "#000" : "#fff",
//                       color: selected === option ? "#fff" : "#000",
//                       border:
//                         selected === option
//                           ? "1px solid #000"
//                           : "1px solid #ddd",
//                       transition:
//                         "background-color 0.25s ease, color 0.25s ease, border 0.25s ease",
//                     }}
//                   >
//                     {optionIcons[option] &&
//                       React.cloneElement(optionIcons[option], {
//                         color: selected === option ? "#fff" : "#000",
//                       })}
//                     <Typography
//                       fontSize={customeStyle.buttomfont}
//                       sx={{
//                         color: selected === option ? "#fff" : "#000",
//                         fontSize: {
//                           xs: "0.85rem",
//                           sm: "0.9rem",
//                           md: "0.94rem", // = 15px
//                           lg: "1rem",
//                         },
//                       }}
//                       align="center"
//                     >
//                       {optionLabels[option] || option}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             </Grid>
//           ))
//         ) : (
//           <Grid item pt={2}>
//             <Typography
//               color={"error"}
//               fontSize={customeStyle.typography.subhading1}
//             >
//               No delivery options available at the moment
//             </Typography>
//           </Grid>
//         )}
//       </Grid>
//     </Fragment>
//   );
// };

// export default ShippingOptionCard;
import React, { Fragment } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { customeStyle } from "utils/style";
import { useSelector } from "react-redux";

const optionIcons = {
  shipping: <LocalShippingIcon />,
  store_pickup: <LocalMallIcon />,
  room_deliver: <LocalMallIcon />,
};

const optionLabels = {
  shipping: "Shipping",
  store_pickup: "Pickup at Store",
  room_deliver: "Deliver to Room",
};

const ShippingOptionCard = ({ selected, onSelcted, selectAddress }) => {
  const handleSelect = (option) => {
    selectAddress();
    onSelcted(option);
  };

  const websiteInfo = useSelector((state) => state.webDetails.websiteInfo);
  const deliveryOptions = websiteInfo?.delivery_option || [];

  return (
    <Fragment>
      <Grid item pb={2}>
        <Typography fontSize="var(--fs-sm)" gutterBottom>
          Please select a delivery method:
        </Typography>
      </Grid>

      <Grid container spacing={{ xs: 1.5, md: 1 }}>
        {deliveryOptions.length > 0 ? (
          deliveryOptions.map((option) => (
            // <Grid key={option} item xs={6} sm={6} md={4}>
            <Grid key={option} item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  overflow: "visible",
                  borderRadius: "1rem",
                  backgroundColor: selected === option ? "#000" : "#fff",
                  position: "relative",
                  width: "100%",
                }}
              >
                {selected === option && (
                  <CheckCircleIcon
                    sx={{
                      position: "absolute",
                      top: -5,
                      right: -5,
                      color: "#1976d2",
                      fontSize: 20,
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      zIndex: 99,
                    }}
                  />
                )}

                <CardActionArea onClick={() => handleSelect(option)}>
                  <CardContent
                    sx={{
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.3rem",
                      borderRadius: "1rem",
                      backgroundColor: selected === option ? "#000" : "#fff",
                      color: selected === option ? "#fff" : "#000",
                      border:
                        selected === option
                          ? "1px solid #000"
                          : "1px solid #ddd",
                    }}
                  >
                    {optionIcons[option] &&
                      React.cloneElement(optionIcons[option], {
                        sx: {
                          color: selected === option ? "#fff" : "#000",
                          fontSize: {
                            xs: "0.9rem",
                            sm: "1rem",
                            md: "1.1rem",
                            lg: "1.2rem",
                          },
                        },
                      })}

                    <Typography
                      fontSize={customeStyle.buttomfont}
                      sx={{
                        color: selected === option ? "#fff" : "#000",
                        fontSize: {
                          xs: "0.75rem",
                          sm: "0.80rem",
                          md: "0.85rem",
                          lg: "0.90rem",
                        },
                      }}
                      align="center"
                    >
                      {optionLabels[option] || option}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item pt={2}>
            <Typography
              color="error"
              fontSize={customeStyle.typography.subhading1}
            >
              No delivery options available at the moment
            </Typography>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default ShippingOptionCard;
